import React, { useState } from "react";
import { Box, Image, Text, Button, SimpleGrid } from "@chakra-ui/react";
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";

import wax from "../images/waxing.jpg";
import lash from "../images/lashes-service.jpg";
import nails from "../images/nails.jpg";
import dip from "../images/dip.jpg";
import kids from "../images/kids.jpg";
import mani from "../images/mani-pedi.jpg";

const services = [
  {
    title: "Waxing",
    img: wax,
  },
  {
    title: "Lashes",
    img: lash,
  },
  {
    title: "Nail Enhancement",
    img: nails,
  },
  {
    title: "Dipping Powder",
    img: dip,
  },
  {
    title: "Kids Services",
    img: kids,
  },
  {
    title: "Mani-Pedi",
    img: mani,
  },
];

function PopularServices() {
  const [current, setCurrent] = useState(0);
  const bodyFont = ["Merienda", "cursive"];

  // Number of items to show based on screen size
  const itemsToShow = {
    base: 1,  // 1 item for mobile
    md: 2,    // 2 items for tablet
    lg: 3,    // 3 items for large screens
  };

  const nextSlide = () => {
    setCurrent((prev) =>
      prev + itemsToShow.lg >= services.length ? 0 : prev + itemsToShow.lg
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev - itemsToShow.lg < 0 ? services.length - itemsToShow.lg : prev - itemsToShow.lg
    );
  };

  return (
    <Box
      position="relative"
      maxW="100vw"
      mx="auto"
      py={10}
      paddingX={["20px", "50px", "100px"]}
      paddingTop={"100px"}
      paddingBottom={"100px"}
      bg={"linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"}
    >
      {/* Carousel Content */}
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3 }}  // 1 column for mobile, 2 for tablets, 3 for desktop
        spacing={8}  // Adjust spacing
        paddingX={["20px", "50px", "50px"]}  // Adjust padding based on screen size
      >
        {services.slice(current, current + itemsToShow.lg).map((service, index) => (
          <Box key={index} textAlign="center" padding={["0", "0", "0"]} margin={0}>
            <Image
              src={service.img}
              alt={service.title}
              borderRadius="full"
              boxSize={["50%", "60%", "60%"]}  // Responsive image size
              objectFit="cover"
              mx="auto"
            />
            <Text fontSize={["xl", "2xl"]} mt={4} fontFamily={bodyFont}>
              {service.title}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {/* Navigation Buttons */}
      <Button
        onClick={prevSlide}
        position="absolute"
        top="50%"
        left={["5%", "10%"]}
        transform="translateY(-50%)"
        bg="transparent"
        _hover={{ bg: "pink.200" }}
      >
        <ArrowBackIcon boxSize={["6", "8"]} />  {/* Larger icons for larger screens */}
      </Button>
      <Button
        onClick={nextSlide}
        position="absolute"
        top="50%"
        right={["5%", "10%"]}
        transform="translateY(-50%)"
        bg="transparent"
        _hover={{ bg: "pink.200" }}
      >
        <ArrowForwardIcon boxSize={["6", "8"]} />
      </Button>
    </Box>
  );
}

export default PopularServices;
